var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMushroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_783_2173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 7.4C13.3332 4.41733 10.9452 2 7.99984 2C5.0545 2 2.6665 4.41733 2.6665 7.4C2.6665 7.55913 2.72972 7.71174 2.84224 7.82426C2.95476 7.93679 3.10737 8 3.2665 8H12.7332C12.8923 8 13.0449 7.93679 13.1574 7.82426C13.27 7.71174 13.3332 7.55913 13.3332 7.4V7.4Z",
    stroke: "#222529",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 8V12.6667C6.6665 13.0203 6.80698 13.3594 7.05703 13.6095C7.30708 13.8595 7.64622 14 7.99984 14C8.35346 14 8.6926 13.8595 8.94265 13.6095C9.19269 13.3594 9.33317 13.0203 9.33317 12.6667V8",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_783_2173"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMushroom);
export default __webpack_public_path__ + "static/media/mushroom.7e5bf37893e7aa3f769f24834d4ec282.svg";
export { ForwardRef as ReactComponent };